import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.replace.js";
import { NavBar, showDialog } from 'vant';
export default {
  name: 'MyNavbar',
  components: {
    [NavBar.name]: NavBar
  },
  props: {
    title: String,
    canReturn: Boolean,
    hint: String,
    clickRight: Function
  },
  data: () => ({
    count: 0
  }),
  methods: {
    leftClick() {
      if (this.canReturn) if (history.length > 1) this.$router.back();else this.$router.replace('/');
    },

    rightClick(args) {
      if (this.hint) showDialog({ ...this.$root.dialogSettings,
        message: this.$t(`hint.${this.hint}`)
      });else if (this.clickRight) this.clickRight(args);
    },

    click() {
      if (!this.canReturn && ++this.count > 10) this.$root.developerMode = true;
    }

  }
};